//language
$('.language').hover(function(){
    $('.lang_popup').show()
},function(){
    $('.lang_popup').hide()
})

//right icon
var flag = true;
$('.main_Mright').click(function(){
    if(flag){
        $('.Mright_line').css({background:'transparent'})
        $(this).addClass('Mright_active')
        $('.Main_popup').css({height:'88vh'})
        flag = !flag
    }else{
        $('.Mright_line').css({background:'black'})
        $(this).removeClass('Mright_active')
        $('.Main_popup').css({height:'0'})
        flag = !flag
    }
})

//mobile popup
$('.Mnav').click(function(){
    var Toheight = $(this).next('.Mnav_link')[0].scrollHeight
    var height = $(this).next('.Mnav_link').css('height')
    if(height == '0px'){
        $(this).children('.Mnav_right').addClass('Mnav_active')
        $(this).next('.Mnav_link').css({height:`${Toheight}px`})
    }else{
        $(this).children('.Mnav_right').removeClass('Mnav_active')
        $(this).next('.Mnav_link').css({height:'0'})
    }
})

//导航栏功能
$(".nav a").hover(function(){
    var index =$(this).index();
    $('.nav a').css({color:'black'})
    $(this).css({color:'#44d62c'})
    if(index != 2){
        $(`.main_popup${index+1}`).css({height:eval(`$('.main_popup${index+1}')[0].scrollHeight`)})
        $('.main_mask').css({height:'96vh'})
    }
},function(){
    $(this).css({color:'black'});
    var index =$(this).index();
    if(index != 2){
        $(`.main_popup${index+1}`).css({"height":"0"})
        $('.main_mask').css({height:'0'})
    }
}) 

//悬窗对应导航变色
$(".main_popup").hover(function(){
    var str = $(this)[0].classList[0]
    var index = str.substring(10)
    $(this).css({height:eval(`$('.main_popup${index}')[0].scrollHeight`)})
    $(`.nav a:nth-child(${index})`).css({color:'#44d62c'});
    $('.main_mask').css({height:'96vh'})
},function(){
    var str = $(this)[0].classList[0]
    var index = str.substring(10)
    $(`.nav a:nth-child(${index})`).css({color:'black'})
    $(this).css({height:'0'})
    $('.main_mask').css({height:'0'})
})

// 产品悬窗产品效果
$('.mp_item').hover(function(){
    $(this).children().children('.mp_img').children('img').css({transform:'scale(1.1)'})
    $(this).find('span').css({color:'#44d62c'})
},function(){
    $(this).children().children('.mp_img').children('img').css({transform:'scale(1)'})
    $(this).find('span').css({color:'black'})
})

//产品悬窗导航栏
$('.mp_nav div').hover(function(){
    var index = $(this).index()+1
    $('.mp_nav div').css({color:'black'})
    $(this).css({color:'#44d62c'});
    $(`.mp_content .mp_product`).hide()
    $(`.mp_content .mp_product:nth-child(${index})`).show()
})


